export const queryKeys = {
  PIPE_TEMPLATE_ALL: "PIPE_TEMPLATE_ALL",
  PIPE_TEMPLATE: "PIPE_TEMPLATE",
  PIPE_CAUSE: "PIPE_CAUSE"
}